import { render, staticRenderFns } from "./InfoProductStrorageAndPreparation.vue?vue&type=template&id=1006ae6a&scoped=true"
import script from "./InfoProductStrorageAndPreparation.vue?vue&type=script&lang=js"
export * from "./InfoProductStrorageAndPreparation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1006ae6a",
  null
  
)

export default component.exports